module.exports = __webpack_public_path__ + "static/img/12.27a1419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin_activity/12.png
// module id = aFST
// module chunks = 0